import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import http from 'hub-http/clients/apiClient';
import { convertMultiLangCategoriesToOldFormat, convertMultiLangEditResponseToOldFormat, getKnowledgeBaseIdIsOnSCP } from '../migration-handler/singleton/migrationHandler';
import { makeSimpleQuickFetchWrapper } from '../utils/ajaxUtils';
const API_BASE = '/knowledge-content/v1/knowledge-category-translations';
const CATEGORY_API_BASE = '/knowledge-content/v1/knowledge-categories';
const SCP_API_BASE = 'knowledge-content/v2/category-organization/knowledge-base';
const SCP_CATEGORY_API_BASE = 'knowledge-content/v2/category';
export default class MultiLanguageCategoriesApi {
  static createMultiLanguage(parentCategoryId, categoryTranslations, knowledgeBaseId, primaryLanguage, homepageSettings) {
    const isOnSCP = getKnowledgeBaseIdIsOnSCP(knowledgeBaseId);
    if (!isOnSCP) {
      const data = {
        parentCategoryId,
        knowledgeCategoryTranslations: categoryTranslations,
        knowledgeBaseId
      };
      return http.post(`${CATEGORY_API_BASE}`, {
        data
      });
    }
    const {
        [primaryLanguage]: primary
      } = categoryTranslations,
      restTranslations = _objectWithoutPropertiesLoose(categoryTranslations, [primaryLanguage].map(_toPropertyKey));

    //on SCP homepageSettings will be required
    const data = {
      knowledgeBaseId,
      name: primary.name,
      description: primary.description,
      color: homepageSettings && homepageSettings.color,
      iconName: homepageSettings && homepageSettings.iconName,
      iconType: homepageSettings && homepageSettings.iconType,
      iconUnicode: homepageSettings && homepageSettings.iconUnicode,
      imageSrc: homepageSettings && homepageSettings.imageSrc,
      imageTypeEnum: homepageSettings && homepageSettings.imageTypeEnum,
      isDisplayed: homepageSettings && homepageSettings.isDisplayed,
      translations: restTranslations,
      parentCategoryId
    };
    return http.post(`${SCP_CATEGORY_API_BASE}/translation`, {
      data
    });
  }
  static updateCategoryTranslations(category, knowledgeBaseId, primaryLanguage) {
    const isOnSCP = getKnowledgeBaseIdIsOnSCP(knowledgeBaseId);
    if (!isOnSCP) {
      const subcategories = category.subcategories.map(subcategory => ({
        knowledgeCategoryId: subcategory.id,
        translations: subcategory.nameTranslations
      }));
      const data = [{
        knowledgeCategoryId: category.knowledgeCategoryId,
        translations: category.nameTranslations
      }, ...subcategories];
      return http.put(`${API_BASE}/categories-translations`, {
        data
      });
    }
    const data = category.nameTranslations.reduce((acc, variant) => {
      const parsedVariant = variant.toJS();
      if (parsedVariant.language === primaryLanguage) {
        acc = Object.assign({}, acc, parsedVariant);
        return acc;
      }
      acc.translations[parsedVariant.language] = parsedVariant;
      return acc;
    }, {
      knowledgeBaseId,
      name: category.name,
      description: category.description,
      articleIds: category.articleIds,
      color: category.color,
      iconName: category.iconName,
      iconType: category.iconType,
      iconUnicode: category.iconUnicode,
      imageSrc: category.imageSrc,
      imageTypeEnum: category.imageTypeEnum,
      isDisplayed: category.isDisplayed,
      position: category.position,
      translations: {}
    });
    return http.put(`${SCP_CATEGORY_API_BASE}/translation/${data.id}`, {
      data,
      timeout: 20000
    }).then(response => {
      return {
        categories: convertMultiLangEditResponseToOldFormat([response]),
        primaryLanguage: category.language,
        requestedLanguages: Object.keys(data.translations)
      };
    });
  }
  static getCategory(categoryId) {
    return http.get(`${SCP_CATEGORY_API_BASE}/${categoryId}`);
  }
}
MultiLanguageCategoriesApi.getMultiLanguageCategories = makeSimpleQuickFetchWrapper(({
  knowledgeBaseId
}) => `get-categories-translations-${knowledgeBaseId}`, ({
  languages,
  includeDescriptions = false,
  includeArticles = false,
  knowledgeBaseId
}) => {
  const isOnSCP = getKnowledgeBaseIdIsOnSCP(knowledgeBaseId);
  if (!isOnSCP) {
    return http.get(`${API_BASE}/categories-translations`, {
      query: {
        language: languages,
        includeDescriptions,
        includeArticles,
        knowledgeBaseId
      }
    });
  }
  return http.get(`${SCP_API_BASE}/${knowledgeBaseId}`, {
    query: {
      language: languages
    }
  }).then(response => ({
    categories: convertMultiLangCategoriesToOldFormat(response.categories),
    primaryLanguage: response.primaryLanguage,
    requestedLanguages: [response.requestedLanguage]
  }));
});